<mat-form-field class="w-full {{ labelStyle }}" appearance="outline">
  <mat-label>{{ labelTitle }}</mat-label>
  <mat-select [formControl]="control" [id]="selectId">
    @for (option of options; track option) {
    <mat-option [value]="option[selectId]">
      {{ option.name }}
    </mat-option>
    }
  </mat-select>
  @if (control.touched) {
  <mat-error>
    <small customLabel [errors]="control.errors"></small>
  </mat-error>
  }
</mat-form-field>
